import axios from "axios";
import { Auth } from "aws-amplify";
import {
  responseSuccessInterceptor,
  responseErrorInterceptor,
} from "./errorHandler";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

axiosInstance.interceptors.request.use(async (config) => {
  try {
    const session = await Auth.currentSession();
    config.headers.Authorization = `Bearer ${session.idToken.jwtToken}`;
    return config;
  } catch (err) {
    Auth.signOut();
    $log.error(err);
    return Promise.reject(err);
  }
});

// Add response interceptors for centralized error handling
axiosInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

export default axiosInstance;
